import styled from 'styled-components';

export const ClearPhrase = styled.span`
  cursor: pointer;
`;
